import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPaginationFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPaginationFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'e05e3d02a746f92d9891183182822ffe14f61301', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '7afdb0a81707ef0659b64447ff0e1e4920c6fdfe', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '29bf0b500619bcd54540b145e82fcda61bb756a0', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2a2.5 2.5 0 1 0 2.5 2.5A2.49 2.49 0 0 0 11 2m0 6.5a2.5 2.5 0 1 0 2.5 2.5A2.49 2.49 0 0 0 11 8.5m-2.5 9A2.5 2.5 0 0 1 11 15a2.49 2.49 0 0 1 2.5 2.5 2.5 2.5 0 0 1-5 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-pagination-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-pagination-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-pagination-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPaginationFilled$1);
            }
            break;
    } });
}

const CosmosIconPaginationFilled = CosmosIconPaginationFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPaginationFilled, defineCustomElement };
